"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultElementsProps = exports.TEXT_WITH_HTML = exports.READ_MORE = void 0;
const READ_MORE = exports.READ_MORE = 'read-more';
const TEXT_WITH_HTML = exports.TEXT_WITH_HTML = 'text-with-html';
const defaultElementsProps = exports.defaultElementsProps = {
  headingProps: {
    align: 'center'
  }
};
//# sourceMappingURL=constants.js.map